import lodash from 'lodash';
import { composeReducers } from 'common/util/composeReducers';
import {
    ADMIN_LOAD_DOCUMENT_TYPES,
    ADMIN_LOAD_DOCUMENT_TYPES_LIST,
    ADMIN_CREATE_DOCUMENT_TYPE,
    ADMIN_UPDATE_DOCUMENT_TYPE,
    ADMIN_DELETE_DOCUMENT_TYPE,
    ADMIN_INITIALIZE_UPDATE_DOCUMENT_TYPE_SCENE,
    ADMIN_CREATE_DOCUMENT_TYPE_DESCRIPTOR_LINK,
    ADMIN_DELETE_DOCUMENT_TYPE_DESCRIPTOR_LINK,
    ADMIN_UPDATE_DOCUMENT_TYPE_DESCRIPTOR_LINK
} from 'institutionalAdmin/actions/documentTypes';

export function loadDocumentTypes(state, action) {
    if (!action || action.type !== ADMIN_LOAD_DOCUMENT_TYPES) {
        return state;
    }

    const { institutionId, documentTypes } = action.payload;
    let currentDocumentTypes = lodash.get(state, ['institutions', 'byId', institutionId, 'documentTypes'], null);

    if (!currentDocumentTypes) {
        currentDocumentTypes = [];
    }

    if (lodash.isEqual(currentDocumentTypes, documentTypes)) {
        return state;
    }

    const result = {
        ...state
    };

    lodash.set(result, ['institutions', 'byId', institutionId, 'documentTypes'], [...documentTypes]);

    return result;
}

export function loadDocumentTypesList(state, action) {
    if (!action || action.type !== ADMIN_LOAD_DOCUMENT_TYPES_LIST) {
        return state;
    }

    const { documentTypes } = action.payload;

    const result = {
        ...state,
        scene: {
            ...state.scene,
            documentTypes
        }
    };

    return result;
}

export function createDocumentType(state, action) {
    if (!action || action.type !== ADMIN_CREATE_DOCUMENT_TYPE) {
        return state;
    }

    const { documentType } = action.payload;

    const currentDocumentTypes = lodash.get(state, 'scene.documentTypes', []);

    const appendedDocumentTypes = currentDocumentTypes.concat(documentType);
    const documentTypes = lodash.sortBy(appendedDocumentTypes, dt => dt.displayName.toLowerCase());

    const result = {
        ...state,
        scene: {
            ...state.scene,
            documentTypes
        }
    };

    return result;
}

// initializeUpdateDocumentTypeScene is only used in Complion Admin although it currently sits inside of Institutional Admin.
// It should be moved to the appropriate place along with any related code that uses it.
export function initializeUpdateDocumentTypeScene(state, action) {
    if (!action || action.type !== ADMIN_INITIALIZE_UPDATE_DOCUMENT_TYPE_SCENE) {
        return state;
    }

    const {
        documentType,
        descriptors,
        dataSources,
    } = action.payload;

    const result = {
        ...state,
        scene: {
            documentType,
            descriptors,
            dataSources,
        }
    };

    return result;
}

export function updateDocumentType(state, action) {
    if (!action || action.type !== ADMIN_UPDATE_DOCUMENT_TYPE) {
        return state;
    }

    const { documentType } = action.payload;

    const result = {
        ...state,
        scene: {
            ...state.scene,
            documentType,
        }
    };

    return result;
}

export function deleteDocumentType(state, action) {
    if (!action || action.type !== ADMIN_DELETE_DOCUMENT_TYPE) {
        return state;
    }

    const { documentTypeId } = action.payload;
    const currentSceneDocumentTypes = lodash.get(state, 'scene.documentTypes', []);

    if (currentSceneDocumentTypes.length === 0) {
        return state;
    }

    const documentTypes = lodash.filter(currentSceneDocumentTypes, dt => dt.id !== documentTypeId);

    const result = {
        ...state,
        scene: {
            ...state.scene,
            documentTypes
        }
    };

    return result;
}

export function createDocumentTypeDescriptorLink(state, action) {
    if (!action
        || (action.type !== ADMIN_CREATE_DOCUMENT_TYPE_DESCRIPTOR_LINK
            && action.type !== ADMIN_DELETE_DOCUMENT_TYPE_DESCRIPTOR_LINK
            && action.type !== ADMIN_UPDATE_DOCUMENT_TYPE_DESCRIPTOR_LINK)) {
        return state;
    }

    const { documentType } = action.payload;

    const result = {
        ...state,
        scene: {
            ...state.scene,
            documentType
        }
    };

    return result;
}

export default composeReducers(
    initializeUpdateDocumentTypeScene,
    loadDocumentTypes,
    loadDocumentTypesList,
    createDocumentType,
    updateDocumentType,
    deleteDocumentType,
    createDocumentTypeDescriptorLink
);
